module.exports = __webpack_public_path__ + "img/dentist-man.0f54dca.png";